module.exports = __webpack_public_path__ + "8d715138fea8cc8603d6218e90e19ae3.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/font/31E6D3_2_0.ttf
// module id = 2250
// module chunks = 2